import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import SearchDropdownRow from '../../rows/SearchDropdownRow';
import AnimateHeight from 'react-animate-height';

import { Icon, UserPicture, Tooltip } from '../../..';
import injected from '../../../injected';
import { utils, errors, translations } from 'gipsy-misc';
import Field from '../../components/Field';

var Assign = function (_PureComponent) {
  _inherits(Assign, _PureComponent);

  function Assign() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Assign);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Assign.__proto__ || Object.getPrototypeOf(Assign)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      multipleAssigneesMode: false
    }, _this.onSelect = function (e, _ref2) {
      var paramName = _ref2.paramName,
          value = _ref2.value;
      var _this$props = _this.props,
          to = _this$props.to,
          multipleAssignees = _this$props.multipleAssignees;

      var data = { paramName: paramName, value: value };

      if (_this.state.multipleAssigneesMode) {
        if (utils.user.areSameUser(value, to) || utils.array.getObjectIndexInArray(multipleAssignees, value, ['userId', 'email']) !== -1) {
          data.method = 'remove';
        } else {
          data.method = 'add';
        }
      }

      _this.props.onChange(data);
      if (!_this.state.multipleAssigneesMode) {
        _this.toggleField(e);
      }
    }, _this.toggleField = function (e) {
      var _this$props2 = _this.props,
          isOpen = _this$props2.isOpen,
          mode = _this$props2.mode,
          to = _this$props2.to,
          multipleAssignees = _this$props2.multipleAssignees;
      var multipleAssigneesMode = _this.state.multipleAssigneesMode;

      _this.props.toggleField(e, _this.props.id);

      if (!multipleAssigneesMode && mode === 'create' && (to || multipleAssignees && multipleAssignees.length > 0)) {
        _this.setState({ multipleAssigneesMode: true });
      }
      if (!isOpen && _this.dropdown && _this.dropdown.focus) {
        _this.timeout = setTimeout(function () {
          return _this.dropdown.focus();
        }, 300);
      }
    }, _this.isAssignedToMe = function () {
      var to = _this.props.to;

      return to && to.userId && to.userId === injected.user.id;
    }, _this.isAssignedFromSomeoneElse = function () {
      var from = _this.props.from;

      return from && from.userId && from.userId !== injected.user.id;
    }, _this.isAssignedToSomeoneElse = function () {
      var to = _this.props.to;

      return to && (to.userId && to.userId !== injected.user.id || !!to.email);
    }, _this.removeAssignee = function () {
      _this.props.onChange({ paramName: 'to', value: null });
      if (_this.dropdown) {
        _this.dropdown.clear();
      }
      if (_this.state.multipleAssigneesMode) {
        _this.setState({ multipleAssigneesMode: false });
      }
    }, _this.handleMultipleAssignees = function (e) {
      _this.toggleField(e);
      _this.setState({ multipleAssigneesMode: true });
    }, _this.renderClosedField = function () {
      var _this$props3 = _this.props,
          mode = _this$props3.mode,
          from = _this$props3.from,
          to = _this$props3.to,
          multipleAssignees = _this$props3.multipleAssignees;

      var isAssignedFromSomeoneElse = _this.isAssignedFromSomeoneElse();
      var isAssignedToSomeoneElse = _this.isAssignedToSomeoneElse();
      var hasMultipleAssignees = !!multipleAssignees;

      var value = void 0,
          displayValue = void 0;
      var fieldLabelElement = void 0,
          iconsElement = void 0;
      switch (true) {
        case isAssignedToSomeoneElse:
          value = to;
          displayValue = value.displayName || value.email || 'Someone';
          fieldLabelElement = React.createElement(
            Fragment,
            null,
            React.createElement(UserPicture, {
              src: value && value.picture,
              size: 24,
              sizeDefault: 16,
              backgroundColor: 'transparent',
              style: { marginRight: 12 }
            }),
            React.createElement(
              'span',
              { className: 'label-text' },
              React.createElement(
                'span',
                null,
                translations.taskPanel.assign.toSomeoneElse,
                ' '
              ),
              React.createElement(
                'span',
                { className: 'name' },
                displayValue
              )
            )
          );
          iconsElement = React.createElement(
            'div',
            { className: 'assignee-icons' },
            mode === 'create' && React.createElement(
              'span',
              { onClick: _this.handleMultipleAssignees, className: 'value icon-wrapper' },
              React.createElement(Icon, { icon: 'AddUser', size: 20 }),
              React.createElement(Tooltip, {
                text: translations.taskPanel.assign.multipleAssignees.tooltip,
                vs: 35,
                hs: 12,
                position: 'top left'
              })
            ),
            React.createElement(
              'span',
              { onClick: _this.removeAssignee, className: 'value icon-wrapper' },
              React.createElement(Icon, { icon: 'Close', size: 12, style: { top: 1 } })
            )
          );
          break;

        case isAssignedFromSomeoneElse:
          value = from;
          displayValue = value.displayName || value.email || 'Someone';
          fieldLabelElement = React.createElement(
            Fragment,
            null,
            React.createElement(UserPicture, {
              src: value && value.picture,
              size: 24,
              sizeDefault: 16,
              backgroundColor: 'transparent',
              style: { marginRight: 12 }
            }),
            React.createElement(
              'span',
              { className: 'label-text' + (!value ? ' gp-underline' : '') },
              React.createElement(
                'span',
                { className: 'name' },
                displayValue
              ),
              React.createElement(
                'span',
                null,
                ' ',
                translations.taskPanel.assign.fromSomeoneElse.toLowerCase()
              )
            )
          );
          break;
        case hasMultipleAssignees:
          value = multipleAssignees;
          fieldLabelElement = React.createElement(
            Fragment,
            null,
            value.map(function (assignee, index) {
              return React.createElement(
                UserPicture,
                {
                  className: 'multiple-assignees-picture',
                  key: utils.user.getKey(assignee),
                  border: '1px solid white',
                  size: 24,
                  src: assignee.picture,
                  style: { marginLeft: index === 0 ? 0 : -8 } },
                React.createElement(Tooltip, { text: utils.user.getDisplayName(assignee), vs: 25, hs: 12, position: 'top right' })
              );
            }),
            React.createElement(
              'span',
              { className: 'label-text' },
              React.createElement(
                'span',
                { className: 'multiple-assignees' },
                ' ',
                translations.taskPanel.assign.multipleAssignees.label
              )
            )
          );
          iconsElement = React.createElement(
            'div',
            { className: 'assignee-icons' },
            React.createElement(
              'span',
              { onClick: _this.removeAssignee, className: 'value icon-wrapper' },
              React.createElement(Icon, { icon: 'Close', size: 12, style: { top: 1 } })
            )
          );
          break;
        default:
          fieldLabelElement = React.createElement(
            Fragment,
            null,
            React.createElement(UserPicture, { size: 24, sizeDefault: 16, backgroundColor: 'transparent', style: { marginRight: 12 } }),
            React.createElement(
              'span',
              { className: 'label-text gp-underline' },
              React.createElement(
                'span',
                null,
                translations.taskPanel.assign.toOther
              )
            )
          );
          break;
      }

      return React.createElement(
        'div',
        { className: 'row gp-layout gp-row gp-space-between' },
        React.createElement(
          'span',
          { className: 'field-label', onClick: _this.toggleField },
          fieldLabelElement
        ),
        iconsElement
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Assign, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen && !this.props.isOpen) {
        var isValidEmail = this.dropdown.state.query && utils.email.validateEmail(this.dropdown.state.query);
        if (isValidEmail && (!this.props.to || this.isAssignedToMe())) {
          this.props.onChange({ paramName: 'to', value: { email: this.dropdown.state.query } });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          onChange = _props.onChange,
          error = _props.error,
          to = _props.to,
          multipleAssignees = _props.multipleAssignees,
          defaultContacts = _props.defaultContacts;

      var value = !!multipleAssignees ? multipleAssignees : to;

      return React.createElement(
        Field,
        {
          className: 'delegate-field' + (isActive ? ' active' : '') + (isOpen ? ' open' : '') + (error === errors.taskPanel.assignTo ? ' error' : ''),
          onClick: utils.DOM.stopPropagation },
        this.renderClosedField(),
        React.createElement(
          AnimateHeight,
          { duration: 300, height: isOpen ? 'auto' : 0 },
          React.createElement(SearchDropdownRow, {
            ref: function ref(_ref3) {
              return _this2.dropdown = _ref3;
            },
            inputIcon: 'User',
            paramName: 'to',
            defaultSuggestions: defaultContacts,
            value: value,
            onChange: onChange,
            onSelect: this.onSelect,
            onClose: this.toggleField,
            showSelectionInDropdown: true
          })
        )
      );
    }
  }]);

  return Assign;
}(PureComponent);

Assign.propTypes = {
  mode: PropTypes.string.isRequired,
  id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  from: PropTypes.any,
  to: PropTypes.any,
  multipleAssignees: PropTypes.any,
  defaultContacts: PropTypes.array.isRequired
};


export default Assign;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Assign/index.js
// module id = 1120
// module chunks = 0